import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import { AppTimer } from './../AppTimer';
import { UserMenu } from './../Components/UserMenu';
import React from 'react';
import { styled } from '@mui/material/styles';

type NavigationAppBarProps = {
  title: React.ReactNode | string;
  middleContent?: React.ReactNode | string;
};

const AppToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  '&.MuiToolbar-root': {
    gap: theme.spacing(10),
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: theme.spacing(48),
    height: theme.spacing(48),
  },
}));

const UserMenuContainer = styled('div')({ display: 'flex', alignItems: 'center' });

export const NavigationAppBar = ({ title, middleContent }: NavigationAppBarProps) => {
  return (
    <AppBar elevation={0} color="transparent" position="static">
      <AppToolbar>
        {title}
        {middleContent}
        <UserMenuContainer>
          <AppTimer />
          <UserMenu />
        </UserMenuContainer>
      </AppToolbar>
    </AppBar>
  );
};
